import React from 'react';
import { bool, func, array } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as checkoutActions from '../../stateManagement/engine/actions/CheckoutActions';
import OrderConfirmationModalLayout from './OrderConfirmationModal';
import { FutureDelivery } from '@wix/wixrest-utils';
import { createI18nObject } from '../../utils/i18nUtils';
import { translate } from 'react-i18next';
import { Modal } from 'wix-style-react';

function OrderConfirmationModal({ isOpen, orderInfo, orderConfirmed, locale, organization, t, ...rest }) {
  const i18n = createI18nObject(t, organization.locale);
  const deliveryTime = FutureDelivery.timeGuaranteeText.getOrderTimeGuaranteeText(
    orderInfo,
    i18n.get,
    organization.timezone,
  );

  return (
    <Modal isOpen={isOpen} dataHook="modal-order-confirmation">
      {isOpen && (
        <OrderConfirmationModalLayout
          deliveryTime={deliveryTime}
          orderNumber={orderInfo.id}
          onDone={orderConfirmed}
          locale={locale}
          {...rest}
        />
      )}
    </Modal>
  );
}

OrderConfirmationModal.propTypes = {
  isOpen: bool,
  onRequestClose: func.isRequired,
  orderConfirmed: func.isRequired,
  comments: array,
};

OrderConfirmationModal.defaultProps = {
  isOpen: false,
  comments: [],
};

function mapStateToProps(state, ownProps) {
  return {
    orderInfo: state.checkout.placeOrderResult.orderInfo,
    locale: state.session.organization.locale,
    comments: state.order.comments,
    organization: state.session.organization,
    ...ownProps,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      orderConfirmed: checkoutActions.orderConfirmed,
    },
    dispatch,
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(translate()(OrderConfirmationModal));
